import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader, PageBody } from "@/components/common/PageHeader";
import EmptyState from "@/components/common/EmptyState";
import ResourceDrawer from "@/components/common/ResourceDrawer";
import { Button } from "@/components/ui/button";
import { Plus, Warehouse } from "lucide-react";

export default function Warehouses() {
    const [items, setItems] = useState([]);
    const [drawer, setDrawer] = useState({ open: false, item: null });
    const load = async () => { const { data } = await api.get("/warehouses"); setItems(data); };
    useEffect(() => { load(); }, []);
    const fields = [{ name: "name", label: "Name", span: 2 }, { name: "address", label: "Address", span: 2 }, { name: "state", label: "State" }];

    return (
        <>
            <PageHeader kicker="INVENTORY" title="Warehouses" subtitle="Multi-location stock tracking."
                actions={<Button onClick={() => setDrawer({ open: true, item: null })}><Plus className="w-4 h-4 mr-1.5" />New warehouse</Button>} />
            <PageBody>
                {items.length === 0 ? <EmptyState icon={Warehouse} title="No warehouses" /> :
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                        {items.map((w) => (
                            <button key={w.id} onClick={() => setDrawer({ open: true, item: w })} className="text-left bg-card border border-border rounded-md p-5 hover:border-gold/40 transition-all">
                                <div className="text-[10px] uppercase tracking-[0.14em] text-muted-foreground">{w.state}</div>
                                <div className="text-[17px] font-semibold mt-1">{w.name}</div>
                                <div className="text-[12px] text-muted-foreground mt-2">{w.address}</div>
                                {w.is_default && <div className="mt-3 text-[10px] uppercase tracking-[0.14em] text-gold">Default location</div>}
                            </button>
                        ))}
                    </div>}
            </PageBody>
            <ResourceDrawer open={drawer.open} onClose={() => setDrawer({ open: false, item: null })} title={drawer.item ? "Edit warehouse" : "New warehouse"} fields={fields} initial={drawer.item || {}} onSave={async (f) => { await api.post("/warehouses", f); await load(); }} />
        </>
    );
}
